const words = [
    {
        word: 'grandfathering',
        explanation: 'the view that prior emissions increase entitlements to future emissions'
    }, {
        word: 'LULUCF',
        explanation: 'land use, land-use change and forestry'
    }, {
        word: 'equity principles',
        explanation: 'the Paris Agreement states that it will be implemented to reflect equity and the principle of common but differentiated responsibilities and respective capabilities'
    }, {
        word: 'non-CO2 emissions',
        explanation: 'methane, nitrous oxide, hydrofluorocarbons, perfluorocarbons, and sulfur hexafluoride'
    }, {
        word: 'carbon budget',
        explanation: 'the amount of carbon a local authority can emit in order to stay on track with global temperatures targets'
    }
]

/**
 * Inspired by https://codepen.io/reiinii1/pen/aPGXEa
 * @param {string} html
 */
export default function addTooltips(html) {

    for (const { word, explanation } of words) {
        html = html.replace(RegExp(word, 'i'), `<span data-tooltip="${explanation}">$&</span>`)
    }
    return html
}
